module.exports = __webpack_public_path__ + "static/media/forkify-gif.2233d11f.gif";